import React from 'react';
import TipSheet from '../components/TipSheet';

const TipSheetPage = () => {
  return (
    <TipSheet/>
  );
};

export default TipSheetPage;
